export default "__VITE_ASSET__DVWXiIUR__"